import { render, staticRenderFns } from "./CustomerRelationshipManagement.vue?vue&type=template&id=febe127a&scoped=true&"
import script from "./CustomerRelationshipManagement.vue?vue&type=script&lang=js&"
export * from "./CustomerRelationshipManagement.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRelationshipManagement.vue?vue&type=style&index=0&id=febe127a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febe127a",
  null
  
)

export default component.exports